import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { CheckpointActionConditionType, CheckpointActionType } from '@fi-shared/checklist/checklist-enum';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { CheckpointActionConditionTypeOptions } from '@fi-shared/checklist/checklist-consts';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-checkpoint-action-condition',
    template: `
        <mat-form-field
            appearance="outline"
            class="full-width custom-arrow-icon rotate-suffix-on-focus "
        >
            <mat-label>{{ inputLabel }}</mat-label>

            <mat-select
                required
                panelClass="fi-select-panel-standard"
                [(ngModel)]="actionCondition"
                (ngModelChange)="onActionConditionChange()"
            >
                @for (option of actionConditionOptions; track option.Id) {
                    <mat-option [value]="option.Id">
                        {{ option.Name | fiAppText }}
                    </mat-option>
                }
            </mat-select>
            <mat-icon matSuffix class="fas fa-caret-down" />

            <mat-hint>{{ inputHint }}</mat-hint>
        </mat-form-field>
    `,
    styleUrls: ['./action-condition.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-action-condition' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiCheckpointActionConditionComponent }],
    standalone: false,
})
export class FiCheckpointActionConditionComponent extends FiComponentsContainer implements OnInit {
    @Input() checkpointActionType: CheckpointActionType;
    @Input() actionCondition: CheckpointActionConditionType;
    @Output() actionConditionChange = new EventEmitter<CheckpointActionConditionType>();
    @Input() inputLabel: string;
    @Input() inputHint: string;

    protected actionConditionOptions: INameIdObj[] = CheckpointActionConditionTypeOptions;

    private readonly availableTaskActionConditionTypes: CheckpointActionConditionType[] = [
        CheckpointActionConditionType.NotOk,
        CheckpointActionConditionType.NotFilledOut,
    ];

    public ngOnInit(): void {
        this.setActionConditionOptions();
    }

    private setActionConditionOptions(): void {
        if (this.checkpointActionType === CheckpointActionType.CreateTask) {
            this.actionConditionOptions = this.actionConditionOptions.filter((option) => {
                return this.availableTaskActionConditionTypes.includes(option.Id);
            });
        }
    }

    protected onActionConditionChange(): void {
        this.actionConditionChange.emit(this.actionCondition);
    }
}
